const AsteriskHighlighter = ({ label }) => {
  if (!label) return null;
  if (typeof label !== "string") return label;

  const parts = label?.split(/(\*)/g);

  return (
    <div>
      {parts?.map((part, index) =>
        part === "*" ? (
          <span
            key={index}
            style={{
              color: "red",
              fontSize: "1rem",
            }}
          >
            *
          </span>
        ) : (
          part
        ),
      )}
    </div>
  );
};
export default AsteriskHighlighter;
